import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '../ScattData.js';

class MarkerData extends TimelineSegmentContentDataBase {
  constructor(name = '') {
    super();
    this.name = name;
  }

  static generateFromRawObj(markerDataRawObj) {
    return new this(markerDataRawObj['name']);
  }

  generateRawObj() {
    let markerDataRawObj = {};
    markerDataRawObj['name'] = this.name;
    return markerDataRawObj;
  }

  toString() {
    return this.name;
  }

  clone() {
    return new this.constructor(this.name);
  }

  isSameAs(that) {
    if (this.name !== that.name) return false;
    return true;
  }

  combine(that) {
    if (this.name.length === 0) {
      if (that.name.length > 0) this.name = that.name;
    } else {
      if ((that.name.length > 0) && (this.name !== that.name)) this.name = `${this.name} ${that.name}`;
    }
  }
}

class MarkerSegmentData extends TimelineSegmentDataBase {
  static contentData = MarkerData;

  constructor(begin, end, markerData, isLocked) {
    super(begin, end, markerData, isLocked);
  }

  static toString() {
    return 'MarkerSegmentData';
  }

  static get name() {
    return 'Marker Data';
  }

  clone() {
    return super.clone(false);
  }
}

export default MarkerSegmentData;
